// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__pCn-5","text":"NotFoundBlock_text__Gth4e","img":"NotFoundBlock_img__33mUs"};